import { buildStatementPdfDocumentDefinition } from "./buildStatementPdfDocument";
import { exportReportPdf } from "../shared/pdfMakeClient";
import { sanitizeFilenamePart } from "../shared/reportPdfFilenames";
import { prepareReportPdfBranding } from "../../helpers/prepareReportPdfBranding";

export function buildStatementPdfFilename(statement) {
  const client = sanitizeFilenamePart(statement?.clientName) || "Client";
  const start = sanitizeFilenamePart(statement?.periodStart) || "period";
  const end = sanitizeFilenamePart(statement?.periodEnd) || "end";
  return `Statement_${client}_${start}_to_${end}.pdf`;
}

export async function downloadClientStatementPdf(statement, { branding } = {}) {
  if (!statement) {
    throw new Error("Statement is required");
  }

  const { branding: resolvedBranding, logoDataUrl } = await prepareReportPdfBranding(branding);
  const docDefinition = buildStatementPdfDocumentDefinition(statement, {
    logoDataUrl,
    branding: resolvedBranding,
  });

  await exportReportPdf(
    docDefinition,
    buildStatementPdfFilename(statement),
    `Statement of Account — ${statement.clientName || "Client"}`,
  );
}
